import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {storeToRefs} from "pinia";
import MarkedFilterButton from './MarkedFilterButton.vue'
import MarkedFilterRangeButton from './MarkedFilterRangeButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MarkedFilterItem',
  setup(__props) {

const filtersStore = useFiltersStore();
const {getActiveFilters} = storeToRefs(filtersStore)


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getActiveFilters), (activeFilter, filterName) => {
    return (_openBlock(), _createElementBlock("span", {
      class: "serp__filters--marked-item",
      key: filterName
    }, [
      (Array.isArray(activeFilter))
        ? (_openBlock(), _createBlock(MarkedFilterButton, {
            key: 0,
            "active-filter": activeFilter,
            "filter-name": filterName
          }, null, 8, ["active-filter", "filter-name"]))
        : (_openBlock(), _createBlock(MarkedFilterRangeButton, {
            key: 1,
            "active-filter": activeFilter,
            "filter-name": filterName
          }, null, 8, ["active-filter", "filter-name"]))
    ]))
  }), 128))
}
}

})